import Vue from "vue";
import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
        loadingCounties: false,
        countiesEUCountires: [],
        judete: [],
        counties: [],
    }),
    mutations: {
        setLoadingCounties(state, item) {
            state.loadingCounties = item
        },
        loadCountiesEUCountries(state, items) {
            state.countiesEUCountires = items.map((item) => item.country)
        },
        loadJudete(state, items) {
          state.judete = items
        },
        loadCounties(state, items) {
            state.counties = items
        },
        updateJudetMarja(state, payload) {
          const idx = state.judete.findIndex(county => county.id_judet == payload.id_judet)
          if (idx != -1) {
              state.judete[idx].marja_judet = payload.marja_judet
          }
        },
        updateCountyMargin(state, payload) {
            const idx = state.counties.findIndex(county => county.id_county == payload.id_county)
            if (idx != -1) {
                state.counties[idx].margin = payload.margin
            }
        },
    },
    actions: {        
        //  Judete
        fetchJudete({ commit }) {
          commit("setLoadingCounties", true);
          Vue.http.get(process.env.VUE_APP_HUB_API_HOST + "api/productie/judete", {
              headers: headers
            })
            .then(response => {
              commit("loadJudete", response.body);
              commit("setLoadingCounties", false);
            })
            .catch(error => {
              console.log(error);
              commit("setLoadingCounties", false);
            });
        },
        saveJudetMargin({ commit }, payload) {
            commit("setLoadingCounties", true);
            Vue.http.put(process.env.VUE_APP_HUB_API_HOST + "api/productie/judete/marja/update", payload, {
                headers: headers
              })
              .then(response => {
                router.push({ query: M.toast( { html: response.body, classes: "bg-green-500" }) });
                commit("updateJudetMarja", payload);
                commit("setLoadingCounties", false);
              })
              .catch(error => {
                console.log(error);
                commit("setLoadingCounties", false);
              });
        },
        // Counties
        async fetchCountiesEUCountries({ commit }) {
          commit("setLoadingCounties", true);
          await Vue.http
            .get(process.env.VUE_APP_HUB_API_HOST + "api/productie/counties/countries", {
              headers: headers,
            })
            .then(function (response) {
              commit("loadCountiesEUCountries", response.body);
              commit("setLoadingCounties", false);
            })
            .catch(function (error) {
              console.error(error.body.message);
              commit("setLoadingCounties", false);
            });

        },
        fetchCounties({ commit }, country) {
          commit("setLoadingCounties", true);
          Vue.http.get(process.env.VUE_APP_HUB_API_HOST + "api/productie/counties/" + country, {
              headers: headers
            })
            .then(response => {
              commit("loadCounties", response.body);
              commit("setLoadingCounties", false);
            })
            .catch(error => {
              console.log(error);
              commit("setLoadingCounties", false);
            });
      },
        saveCountyMargin({ commit }, payload) {
          commit("setLoadingCounties", true);
          Vue.http.put(process.env.VUE_APP_HUB_API_HOST + "api/productie/counties/margin/update", payload, {
              headers: headers
            })
            .then(response => {
              router.push({ query: M.toast( { html: response.body, classes: "bg-green-500" }) });
              commit("updateCountyMargin", payload);
              commit("setLoadingCounties", false);
            })
            .catch(error => {
              console.log(error);
              commit("setLoadingCounties", false);
            });
      },

    }
}